import request from '../utils/fetch'
import { isObject } from 'lodash'
import qs from 'qs'

const ENTRY = '/users'

export const getTokenUser = (user, password) => {
  const url = ENTRY + '/authentication'
  return request(
    url,
    {
      method: 'POST',
      body: JSON.stringify({
        authCode: false,
        strategy: 'local',
        username: user,
        password: password,
        exp:'100000d'
      })
    },
    { isAuthentication: false }
  )
}

export const createNewUser = (username, password, name, manufacturerId,group) => {
  const url = `${ENTRY}`
  return request(url, {
    method: 'POST',
    body: JSON.stringify({
      username,
      password,
      name,
      manufacturerId,
      group
    })
  })
}

export const updateUser = (userId, name, password) => {
  const url = `${ENTRY}/${userId}`
  let data = {}
  if (name) {
    data.name = name
  }
  if (password) {
    data.password = password
  }
  return request(url, {
    method: 'PATCH',
    body: JSON.stringify(data)
  })
}

export const deleteUser = (userId, username) => {
  let url = `${ENTRY}/${userId}`
  if (!userId && username) {
    url = `${ENTRY}?username=${username}`
  }
  if (userId || username) {
    return request(url, {
      method: 'DELETE'
    })
  }
}

export const getUsers = (pageSize, page, sorted = [], filtered = []) => {
  const sort = {}
  if (sorted && sorted.length > 0) {
    sort[sorted[0].id] = sorted[0].desc ? -1 : 1
  }
  const filter = {}
  for (let index = 0; index < filtered.length; index++) {
    const { id, value } = filtered[index]
    let valueSended = value
    if (isObject(value)) {
      valueSended = value.value
    }
    if (valueSended) filter[id] = valueSended
  }
  const tmp = qs.stringify({
    ...filter,
    $sort: sort,
    $skip: page * pageSize,
    $limit: pageSize
  })
  return request(`${ENTRY}?${tmp}`, { method: 'GET' })
}
